const galleryCz = {
    "file_upload_successful": "Nahrání souboru bylo úspěšné",
    "file_upload_error": "Chyba při nahrávání souboru",
    "attach_files": "Přiložit soubory",
    "files_selected": "Vybrané soubory",
    "upload": "Nahrát",
    "uploading": "Nahrávání",
    "maximum_file_size": "Maximální povolená velikost pro nahrávání je 10 MB.",
    "download": "Stáhnout",
    "open_in_new_tab": "Otevřít v nové kartě",
    "delete_file": "Smazat soubor",
    "confirm_delete": "Jste si jisti, že chcete tento soubor smazat?",
    "image_in_use": "Vybraný obrázek se používá v následujících aktivních položkách nabídky:",
    "image_in_use_tip": "Chcete-li tento soubor smazat, odeberte jej prosím ze všech aktivních záznamů.",
    "file_deleted_successfully": "Soubor byl úspěšně smazán",
    "error_deleting_file": "Chyba při mazání souboru",
    "confirm_selection": "Potvrdit výběr",
    "file_deletion_forbidden": "Mazání souborů zakázáno"
};

export default galleryCz;
